import React from 'react';
import '../Style/Location.css';
import { FaMapMarkerAlt } from 'react-icons/fa';

const Location = () => {
  return (
    <div className="map-container">
      <iframe
        title="Sundar Industrial Estate Map"
        src="https://www.google.com/maps?q=Sundar+Industrial+Estate,+Lahore,+Pakistan&output=embed"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>

      <div className="map-links">
        <a
          href="https://www.google.com/maps/dir/?api=1&destination=Sundar+Industrial+Estate,+Lahore"
          target="_blank"
          rel="noopener noreferrer"
        >
          Directions
        </a>
        <span>|</span>
        <a
          href="https://www.google.com/maps/place/Sunder+Small+Industrial+Estate+II/@31.3168622,74.151465,619m/data=!3m2!1e3!4b1!4m6!3m5!1s0x391855b351f06949:0x4d3a96c03254b37a!8m2!3d31.3168576!4d74.1540399!16s%2Fg%2F11fzd2k323?authuser=0&entry=ttu&g_ep=EgoyMDI1MDcyMC4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
        >
          View larger map
        </a>
      </div>
    </div>
  );
};

export default Location;